
export const BUILD_NAV_ITEMS = 'BUILD_NAV_ITEMS'

export const UPDATE_NAV_ITEMS = 'UPDATE_NAV_ITEMS'

export const BUILD_MENU = 'BUILD_MENU'

export const SET_USER = 'SET_USER'

export const SET_STYLES = 'SET_STYLES'

export const SET_APP_STATE = 'SET_APP_STATE'

export const SET_CS_CACHE_KEY = 'SET_CS_CACHE_KEY'

export const SET_CS_RELOAD_REQ = 'SET_CS_RELOAD_REQ'

export const SET_CS_LOGGING_IN = 'SET_CS_LOGGING_IN'

export const SET_CS_SESSION_EXPIRED = 'SET_CS_SESSION_EXPIRED'

export const SET_CLUB_SETTINGS = 'SET_CLUB_SETTINGS'

export const SET_APP_CONFIG = 'SET_APP_CONFIG'
